export const GENERIC_FAVICONS = [{
    name: 'favicon-32.png',
    sizes: '32x32'
}, {
    name: 'favicon-57.png',
    sizes: '57x57'
}, {
    name: 'favicon-76.png',
    sizes: '76x76'
}, {
    name: 'favicon-96.png',
    sizes: '96x96'
}, {
    name: 'favicon-128.png',
    sizes: '128x128'
}, {
    name: 'favicon-192.png',
    sizes: '192x192'
}, {
    name: 'favicon-228.png',
    sizes: '228x228'
}];

export const IOS_FAVICONS = [{
    name: 'favicon-120.png',
    sizes: '120x120'
}, {
    name: 'favicon-152.png',
    sizes: '152x152'
}, {
    name: 'favicon-180.png',
    sizes: '180x180'
}];
